<div class="w-full bg-white border-box radius-10" [style.border]="isValidated ? '2px solid #28a745' : 'none'"
  style="border-radius: 10px;" id="contact-verif">
  <div class="p-20 flex content-between" style="border-bottom: solid 1px #F0F5FF;">
    <div class="flex gap-10 align-items-center">
      <div>
        <div class="flex gap-10 align-items-center mb-5">
          <img *ngIf="!isValidated" src="assets/square-icon.svg" alt="">
          <img *ngIf="isValidated" src="assets/valid-square-icon.svg" alt="" width="40px">
          <div>
            <p class="no-margin light-blue bold">6. Clôturer le scrutin à blanc</p>
            <p class="no-margin dark-gray text-sm">Fermeture du scrutin et envoi des mails de déscellement.</p>
          </div>
        </div>
      </div>
    </div>

  </div>


  <div id="information-grid" class="p-20">
    
    <v8te-active-button [buttonText]="'Clôturer le scrutin à blanc'"
      [boxShadow]="'0px 3px 6px #00000008'" [primaryColor]="'linear-gradient(90deg, #EF4444 0%, #F56D24 100%)'"
      [secondaryColor]="'linear-gradient(90deg, #EF4444 0%, #F56D24 100%)'" [textPrimaryColor]="'#FFFFFF'"
      [textSecondaryColor]="'#FFFFFF'" [iconPosition]="'left'" [border]="'none'" [active]="!isValidated"
      [cursor]="!isValidated ? 'pointer' : 'not-allowed'"
      [icon]="'assets/teletransmission-white-icon.svg'" [iconAlt]="'send icon'" (click)="!isValidated && inviteAssessorsEvent.emit()"
      [height]="'40px'" [minWidth]="'180px'" [width]="'180px'"></v8te-active-button>

  </div>
</div>